<script setup lang="ts">
import { computed } from 'vue'
import { useWindowSize } from '@vueuse/core'
import DesktopMegaMenu from '@/components/DesktopMegaMenu.vue'
import MobileMenuOverlay from '@/components/MobileMenuOverlay.vue'
import { useMenuData } from '@/composables/useMenuData'

const { width } = useWindowSize()
const isDesktop = computed(() => width.value > 1280)
const { menu } = useMenuData()
</script>

<template>
  <DesktopMegaMenu v-if="isDesktop" :menu="menu" />
  <MobileMenuOverlay v-else />
</template>
